import { render, staticRenderFns } from "./KajJeCC.vue?vue&type=template&id=84ef29b6&scoped=true"
import script from "./KajJeCC.vue?vue&type=script&lang=js"
export * from "./KajJeCC.vue?vue&type=script&lang=js"
import style0 from "./KajJeCC.vue?vue&type=style&index=0&id=84ef29b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ef29b6",
  null
  
)

export default component.exports